import { Component, inject, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { TrustArcZindexOptions } from '@trustarc/primeng-theme';
import { PrimeNG } from 'primeng/config';
import { map } from 'rxjs/operators';
import { SysInfoService } from './modules/aaacommon/api/sys-info.service';
import { SystemInfo } from './modules/aaacommon/interface/system-info';
import { AAATranslateService } from './modules/aaacommon/services/aaa-translate.service';
import { ArcService } from './services';
import { MomentService } from './services/moment.service';
import { PlatformNavService } from './services/platform-nav.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private primeNg = inject(PrimeNG);

  systemInfo: string;

  constructor(
    private sysInfoApi: SysInfoService,
    private momentService: MomentService,
    private translate: AAATranslateService,
    private platformNavService: PlatformNavService,
    private router: Router,
    private renderer: Renderer2,
    private arcService: ArcService,
  ) {
    this.arcService.initListeners(
      this.router,
      this.platformNavService,
      this.renderer,
    );
  }

  ngOnInit(): void {
    this.primeNg.zIndex = TrustArcZindexOptions;
    this.sysInfoApi
      .getInfo()
      .pipe(
        map(
          (build: SystemInfo) =>
            `version: ${build.version} timestamp:${this.momentService.formatTimeStamp(build.buildTimestamp)}`,
        ),
      )
      .subscribe((systemInfo) => (this.systemInfo = systemInfo));
    this.translate.loadTokenLanguage();
    const currentRouterUrl = this.router.url;
    const data = {
      item: {
        url: currentRouterUrl,
      },
    };
    this.platformNavService.navigate(data);
  }
}
